module.exports = require('./helpers/bundle-url').getBundleURL('6qsPi') + "match-browser.cf8cedaf.svg";